import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { parseMarketAnalysisPostPage } from '../utils/marketAnalysisContent';

export const useMarketAnalysisPost = (slug) => {
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      if (!slug) {
        setPost(null);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);

      try {
        const page = await getPublicPage(slug);
        if (!isMounted) {
          return;
        }

        setPost(parseMarketAnalysisPostPage(page));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setPost(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  return { post, isLoading, error };
};
